import http from './http';

const getData = (url, headers) => http.get(url, { headers });

export default getData;
